export const SHOW_ERROR = '[UI] Show Error';
export const RESET_ERROR = '[UI] Reset Error';

export const START_LOADING = '[UI] Start Loading';
export const FINISH_LOADING = '[UI] Finish Loading';

export const CREATE_DIALOG = '[UI] Create Dialog';
export const OPEN_DIALOG = '[UI] Open Dialog';
export const CLOSE_DIALOG = '[UI] Close Dialog';
export const DESTROY_DIALOG = '[UI] Destroy Dialog';

export const CHANGE_MOBILE = '[UI] Change mobile';
export const SET_MODAL_OPENED = '[UI] Open modal';
export const SET_MODAL_CLOSE = '[UI] Close Modal';
export const TOGGLE_BACKDROP = '[UI] Toggle backdrop';

export const SHOW_SNACKBAR = '[UI] Show Snackbar';
export const HIDE_SNACKBAR = '[UI] Hide Snackbar';

export const SHOW_SNACKBAR_STATUS = '[UI] Show Snackbar Status';
export const HIDE_SNACKBAR_STATUS = '[UI] Hide Snackbar Status';

export const RESET_UI = '[UI] Reset';

export const NOOP = '[UI] NOOP';

export const PAGE_WHERE_CAME_FROM = '[UI] Page Where I Came From';
